// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-icon {\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  cursor: pointer;\n  border: 1px solid #2D2D2D;\n  border-radius: 50%;\n  padding: 15px;\n}", ""]);
// Exports
module.exports = exports;
